module.exports = __webpack_public_path__ + "img/Cancel.89ca4292.svg";